// React binding for the google.js connection state. SSR-safe: the server
// snapshot is a stable "disconnected" object (ssrtest renders Settings).
import { useSyncExternalStore } from 'react'
import { subscribeGoogle, getGoogleState } from './google.js'

const SERVER_STATE = { status: 'disconnected', error: null }

export function useGoogle() {
  return useSyncExternalStore(subscribeGoogle, getGoogleState, () => SERVER_STATE)
}
